export const price = (price: number): string =>
  new Intl.NumberFormat("de-DE").format(price);
export const thousand = (price: number): string =>
  price.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1 ");
